import { render } from "./Switch.vue?vue&type=template&id=5df6fde2"
import script from "./Switch.vue?vue&type=script&lang=ts"
export * from "./Switch.vue?vue&type=script&lang=ts"

import "./Switch.vue?vue&type=style&index=0&id=5df6fde2&lang=css"
script.render = render

export default script